var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.2,101.3l25.4-25.4l-7.3-7.3L22,94c-2,2-2,5.3,0,7.3S27.2,103.3,29.2,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,77.7L9.2,124.9c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0L63.8,85L56.5,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,37.3c2.5,0,4.7-1,6.4-2.6c1.6-1.6,2.6-3.9,2.6-6.4s-1-4.7-2.6-6.4c-1.6-1.6-3.9-2.6-6.4-2.6c-2.5,0-4.7,1-6.4,2.6 c-1.6,1.6-2.6,3.9-2.6,6.4s1,4.7,2.6,6.4C78.8,36.3,81.1,37.3,83.6,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,41.1H51.7l-13-13c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3l14.5,14.5c1,1,2.3,1.5,3.6,1.5h15.1L51,65l16.4,16.4 l29.9-29.9h33.9c2.8,0,5.1-2.3,5.1-5.1C136.4,43.4,134,41.1,131.2,41.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.6,13c3.5,0,6.3,2.8,6.3,6.3s-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3S44.1,13,47.6,13 M47.6,10.3c-5,0-9,4-9,9s4,9,9,9 s9-4,9-9S52.5,10.3,47.6,10.3L47.6,10.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandball);
export default __webpack_public_path__ + "static/media/handball.25937782240ac2f209b06c4ea06e6556.svg";
export { ForwardRef as ReactComponent };